import type { CustomCommunity4 } from '~/types'

export const useCommunitySchema = (
  community?: MaybeRef<CustomCommunity4 | undefined>,
) => {
  const route = useRoute()
  const runtimeConfig = useRuntimeConfig()
  const { baseUrl } = runtimeConfig.public

  return computed(() => {
    const rawCommunity = unref(community)
    if (
      !rawCommunity ||
      !rawCommunity?.type?.slug ||
      (rawCommunity.type.slug !== 'jeu' && rawCommunity.type.slug !== 'console')
    ) {
      return {}
    }

    const commonSchema = {
      image: rawCommunity.image_og?.url ?? rawCommunity.image_desktop?.url,
      name: rawCommunity.title,
      url: `${baseUrl}${route.path}`,
      aggregateRating:
        rawCommunity.stats?.total_review && rawCommunity.stats.rating
          ? {
              '@type': 'AggregateRating',
              url: `${baseUrl}${route.path}/avis-joueurs`,
              reviewCount: rawCommunity.stats.total_review,
              ratingValue: rawCommunity.stats.rating,
              // fixed value
              worstRating: '1',
              bestRating: '5',
            }
          : undefined,
    }

    if (rawCommunity.type.slug === 'jeu') {
      const consoleNames = rawCommunity.consoles?.map(({ name }) => name)

      return jsonLdScript(
        {
          '@context': 'https://schema.org',
          '@type': 'VideoGame',
          applicationCategory: 'game',
          ...commonSchema,
          genre: rawCommunity.game_types?.map(({ name }) => name),
          gamePlatform: consoleNames,
          operatingSystem: consoleNames,
          contentRating: rawCommunity.pegi
            ? `PEGI ${rawCommunity.pegi}`
            : undefined,
        },
        'community-schema',
      )
    }

    // Google wants offers, review or aggregateRating on a Product ("Extraits de produits", critical): a console
    // nobody reviewed yet gets no Product at all rather than an invalid one (its breadcrumb stays)
    if (rawCommunity.type.slug === 'console' && commonSchema.aggregateRating) {
      return jsonLdScript(
        {
          '@context': 'https://schema.org',
          '@type': 'Product',
          ...commonSchema,
          brand: {
            '@type': 'Brand',
            name: 'Sony',
          },
          description: rawCommunity.description,
        },
        'community-schema',
      )
    }
    return {}
  })
}
